import React from 'react';
import TimelineItemRail from './TimelineItemRail';
import { Box, Flex } from 'rebass';

type TimelineItemSpacer = {
  noRail?: boolean;
  height?: number;
};

const TimelineItemSpacer: React.FC<TimelineItemSpacer> = ({
  height = 10,
  noRail = false,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      sx={{
        position: 'relative',
      }}
    >
      {!noRail && <TimelineItemRail noDot />}
      <Box flexGrow="1" height={height} />
    </Flex>
  );
};

export default TimelineItemSpacer;
